import { List } from "antd"
import { PopOver } from "../../common"

const SimpleInfoList = props => {
  const { list, children } = props
  return (
    <PopOver
      content={
        <List
          size="small"
          dataSource={list}
          onClick={e => e.stopPropagation()}
          renderItem={item => (
            <List.Item>
              {item[0] === "heading" ? (
                <strong>{item?.[1]}</strong>
              ) : (
                <>
                  <div className="gray-700">{item[0]}</div>
                  <div style={{ textAlign: "right", marginInlineStart: "12px" }}>{item[1]}</div>
                </>
              )}
            </List.Item>
          )}
        />
      }
    >
      {children}
    </PopOver>
  )
}

export default SimpleInfoList
